import React from 'react'
import { SmartTooltip } from '../../components/SmartTooltip/SmartTooltip'
import { KTIcon } from '../../_metronic/helpers'

type Props = {
  /** Explanation text. If empty/undefined the hint renders nothing. */
  text?: React.ReactNode
  className?: string
}

// Round "?" icon that reveals a plain-language explanation on hover/focus via
// the house SmartTooltip. Placed inline next to a metric/chart/alert label so
// non-technical staff can learn what a number means without leaving the page.
// The child MUST stay a real DOM element — SmartTooltip injects hover handlers
// through React.cloneElement and silently no-ops on a component that doesn't
// forward them.
const InfoHint: React.FC<Props> = ({ text, className }) => {
  if (!text) return null
  // Длинные подсказки пишутся абзацами через пустую строку — без pre-line они
  // слипаются в сплошную стену текста, которую никто не дочитывает.
  const content =
    typeof text === 'string' ? <span style={{ whiteSpace: 'pre-line' }}>{text}</span> : text
  // Дефолтные 260px по высоте режут многоабзацную подсказку на полуслове: внутри
  // есть прокрутка, но на macOS её полоса невидима, и текст читается обрезанным.
  return (
    <SmartTooltip content={content} maxWidth={380} maxHeight={520}>
      <span
        className={`text-gray-500 text-hover-primary d-inline-flex align-items-center ms-1 ${
          className ?? ''
        }`}
        style={{ cursor: 'help', verticalAlign: 'middle' }}
        tabIndex={0}
        role='img'
        aria-label='Пояснение'
      >
        <KTIcon iconName='question-2' className='fs-6' />
      </span>
    </SmartTooltip>
  )
}

export default InfoHint
